import { DOCUMENT, AsyncPipe } from '@angular/common';
import { Component, OnDestroy, Inject, Renderer2 } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'wm-libs-toggle-theme',
  templateUrl: './toggle-theme.component.html',
  styleUrls: ['./toggle-theme.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
})
export class ToggleThemeComponent implements OnDestroy {
  private themeSubscription: Subscription;
  isDarkMode$: Observable<boolean>;

  constructor(
    private themeService: ThemeService,
    @Inject(DOCUMENT) document: Document,
    private renderer: Renderer2
  ) {
    this.isDarkMode$ = this.themeService.isDarkMode$;

    this.themeSubscription = this.themeService.isDarkMode$.subscribe(
      (isDarkMode) => {
        renderer.removeClass(document.body, 'light-theme');
        renderer.removeClass(document.body, 'dark-theme');
        renderer.addClass(
          document.body,
          isDarkMode ? 'dark-theme' : 'light-theme'
        );
      }
    );
  }

  toggleDarkMode() {
    this.themeService.toggleDarkMode();
  }

  ngOnDestroy() {
    this.themeSubscription.unsubscribe();
  }
}
